namespace advisorop.components.widgets {

    export class NotificationAlertListController {
        public model: Array<domains.IAlertLog>;
        //public dg;
        n: number;
        showArchived: boolean = false;
        private isUpdated: boolean;
        showInformationalMessages: boolean = false;
        true: boolean = true;
        counters: domains.IAlertCounters;

        static $inject = ["generalService", "$rootScope"];
        constructor(public generalService: services.GeneralService, private $rootScope: ng.IRootScopeService) {

            this.$rootScope.$on('alertCounterChanged', (event: ng.IAngularEvent) => {
                this.counters = this.generalService.getAlertCounters();
            });

            //this.$rootScope.$on('alertListChanged', (event: ng.IAngularEvent) => {
            //    //this.model = data;
            //    this.generalService.getAlerts(this.showArchived, this.showInformationalMessages, null, null, null, null, false)
            //        .success((data) => {
            //            this.model = data;
            //        }).error((data, status) => {
            //            toastr.error("Alert list error: " + status + ":" + data);
            //        });
            //});
        }

        $onInit() {
            this.generalService.getAlerts(this.showArchived, this.showInformationalMessages)
                .success((data) => {
                    this.model = data;
                }).error((data, status) => {
                    toastr.error("Alert list error: " + status + ":" + data);
                });
        }

        $routerOnActivate(next, previous) {
        }
    }


    class NotificationAlertList implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                n: "<"
            };
            this.controller = NotificationAlertListController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/common/notification-alert-list.html';
        }
    }
    angular.module(Constants.APP).component("notificationAlertList", new NotificationAlertList());
}